import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { AzureAdTenant } from '../models/ad-tenant';
import { AzureADSettings } from '../models/azure-ad-settings';

@Injectable({
  providedIn: 'root'
})
export class AzureAdService {

  constructor(
    private httpService: JsonHttpService) {
  }

  getTenants(): Promise<AzureAdTenant[]> {
    return this.httpService.get('/api/azure-ad/get-tenants').toPromise();
  }

  saveTenant(item: AzureAdTenant): Promise<AzureAdTenant> {
    return this.httpService.post('/api/azure-ad/save-tenant', item, undefined, false).toPromise();
  }

  deleteTenant(id: number, useGenericErrorHandling: (err: any, caught: Observable<any>) => boolean = _ => true): Promise<void> {
    const options = { params: new HttpParams().set('azureAdTenantsId', id.toString()) };
    return this.httpService.postWithErrorEval('/api/azure-ad/delete-tenant', null, options, useGenericErrorHandling).toPromise();
  }

  async getAzureADSettings(): Promise<AzureADSettings> {
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
    };
    return await this.httpService.getTyped<AzureADSettings>('api/azure-ad/get-settings', options, false, true).toPromise();
  }

  async saveAzureADSettings(item: AzureADSettings): Promise<AzureADSettings> {
    return this.httpService.post('api/azure-ad/save-settings', item).toPromise();
  }
}
